// extracted by mini-css-extract-plugin
export default {"experienceBar":"ExperienceBar_experienceBar__-8QNG","currentExperience":"ExperienceBar_currentExperience__yK-Wi"};